import React, {useEffect, useState, useRef} from 'react'
import { CButton, CSpinner ,CCard, CRow, CCol, CCardHeader, CCardBody, CListGroup, CListGroupItem, CInput } from '@coreui/react'
import { Link, useHistory } from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import CIcon from '@coreui/icons-react'
const url = process.env.REACT_APP_BACK_URL;

const Problems = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const problems = useSelector((state) => state.problems.data);
    const [stateProblems, setStateProblems] = useState([])
    const [isLoading, setLoading] = useState(false)
    const initialRender = useRef(true)

    const remove = (problem) => {
      setLoading(true);
      fetch(`${url}/prv/elements/problems/` + problem.slug, {
        headers: {
          'Authorization': 'bearer ' + localStorage.getItem('inecip_access_token'),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'DELETE'
      })
      .then(() => dispatch({type: 'removeProblem', problem}))
    }

    const filterDimensions = (e) => {
      setStateProblems(problems.filter((problems) => problems.title.includes(e.target.value)))
    }

    const findElementPosition = (stateElement) =>
      problems.indexOf(problems.find(el => el.slug === stateElement.slug))

    useEffect(() => {
      setLoading(true)
      fetch(`${url}/prv/users`, {
        headers: {
          'Authorization': 'bearer ' + localStorage.getItem('inecip_access_token'),
          'Accept': 'application/json',
          'Content-Type': 'application/json'}})
          .then(() => {            
            fetch(`${url}/pub/elements/problems`)
            .then(response => response.json())
            .then(response => dispatch({type: 'setProblems', data: response.elements[0].tree_elements_complete}))
            .then(() => initialRender.current = false)
          })
      .catch(() => history.push('/'))      
    },[])

    useEffect(() => {
      if (!initialRender.current) {
        setStateProblems(problems);
        setLoading(false);
      }
    }, [problems])

    return(
        <>
          {isLoading ? <CSpinner style={{display:'block', margin: '0 auto'}}/> : 
        <CRow>
        <CCol xs={12}>
        <CCard className="mb-4">
            <>
              <CCardHeader>
                <strong style={{verticalAlign:'sub'}}>Listado de problemas</strong>
                {problems && problems.length > 0 && <CInput
                    type="dimensionsFilter"
                    id="dimensions"
                    name="dimensions"
                    placeholder="Filtrar Problemas"
                    className="dimensionsFilter"
                    onChange={filterDimensions}
                  />
                }
                <Link to="/problems/new">
                    <CButton type="button" color="danger" id="button-addon1" style={{float:'right'}}>
                        Nuevo problema
                    </CButton>
                </Link>
              </CCardHeader>
              {stateProblems.length > 0 &&
                <CCardBody>
                    <CListGroup>
                        {stateProblems.map((problem, index) => (
                            <div style={{position: 'relative'}}>
                              <Link to={"/problems/" + findElementPosition(problem)}>
                                  <CListGroupItem style={{backgroundColor: problem.color}} key={index}>
                                      <span style={{textDecoration: 'none', color: 'black'}}>{problem.title}</span>
                                  </CListGroupItem>
                              </Link>
                              <div onClick={() => {if (window.confirm(`Seguro que queres eliminar el problema "${problem.title}" ?`)) remove(problem)}} className="dimensionRemove">
                                <CIcon name='cil-trash' style={{color: 'black'}}/>
                              </div>
                            </div>
                        ))}
                    </CListGroup>
                </CCardBody>}
            </>
          </CCard>
        </CCol>
        </CRow>
            }
    </>
    )

}

export default Problems;